export default __webpack_public_path__ + "static/media/imagebg2.868b520b.png";